














import Vue from 'vue';
import { mapGetters } from 'vuex';
import OrgPicker from '@/components/UI/OrgPicker.vue';

export default Vue.extend({
  name: 'AdminControls',
  components: {
    OrgPicker,
  },
  data() {
    return {
      hideAdminView: false,
    };
  },
  computed: {
    ...mapGetters(['isAdmin']),
  },
});
